import { api } from './client'

// SmartLabIrrigationSettings is the frontend-safe view of the SmartLab
// irrigation API account. The password is never returned — has_password only
// reports whether one is stored.
export interface SmartLabIrrigationSettings {
    enabled: boolean
    base_url: string
    username: string
    has_password: boolean
    updated_at?: string
}

export interface UpdateSmartLabIrrigationSettingsRequest {
    enabled: boolean
    base_url: string
    username: string
    // password: omit or leave empty to keep the stored one.
    password?: string | null
}

export const smartLabIrrigationSettingsApi = {
    get: () =>
        api.get<SmartLabIrrigationSettings>('/smartlab/irrigation/settings'),
    update: (data: UpdateSmartLabIrrigationSettingsRequest) =>
        api.put<SmartLabIrrigationSettings>(
            '/smartlab/irrigation/settings',
            data,
        ),
}
